import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { resetProjectSubprojects } from '#action/list-filter/index';
import {
  MobileRadioContainer,
  MobileLabel,
  ButtonGroup,
  RadioButtonLight,
  RadioButtonDark
} from '#component/general/list-filter/components/mobile/radio-button-group/styles';

export const MobileSubprojectRadioButtonsGroup = ({
  mobileLabel,
  name,
  relatedTo,
  options,
  onChange
}) => {
  const dispatch = useDispatch();
  const search = useSelector(s => s.listFilter?.[relatedTo]?.search?.value, shallowEqual) ?? '';
  const device = useSelector(s => s.listFilter?.[relatedTo]?.device?.value, shallowEqual) ?? [];
  const user = useSelector(s => s.listFilter?.[relatedTo]?.user?.value, shallowEqual) ?? [];
  const selected = useSelector(s => s.listFilter?.[relatedTo]?.[name]?.value, shallowEqual) ?? {};
  const defaultValue = options.find(o => o.data.default)?.data?.value ?? options?.[0]?.data?.value;
  const val = selected?.[0]?.data?.value || defaultValue;
  const [value, setValue] = useState(val);
  const disabled = device.length || user.length || !search.length;

  useEffect(() => {
    if (val !== value) {
      setValue(val);
    }
  }, [val, value]);

  useEffect(() => {
    if ((device.length || user.length || !search.length) && value !== defaultValue) {
      dispatch(resetProjectSubprojects());
    }
  }, [device.length, user.length, search.length, dispatch, value, defaultValue]);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    onChange(options.filter(o => o.data.value === newValue));
  };

  return (
    <MobileRadioContainer>
      <MobileLabel
        fontWeight={500}
        color="textSecondary"
      >
        {mobileLabel}
      </MobileLabel>
      <ButtonGroup>
        {options.map((option, index) => {
          const { label: buttonLabel, data: optionData } = option;
          const optionValue = optionData.value;

          let borderRadius = '0';
          if (index === 0) borderRadius = '8px 0 0 8px';
          if (index === options.length - 1) borderRadius = '0 8px 8px 0';

          const isSelected = value === optionValue;
          const ButtonComponent = isSelected ? RadioButtonLight : RadioButtonDark;

          return (
            <ButtonComponent
              key={`${buttonLabel}_${optionValue}`}
              type="button"
              variant="contained"
              onClick={() => handleChange(null, optionValue)}
              style={{ borderRadius }}
              color={isSelected ? 'secondary' : 'inherit'}
              disabled={disabled}
            >
              {buttonLabel}
            </ButtonComponent>
          );
        })}
      </ButtonGroup>
    </MobileRadioContainer>
  );
};
